import { render, staticRenderFns } from "./setPassword.vue?vue&type=template&id=5bdc5ffa&scoped=true&"
import script from "./setPassword.vue?vue&type=script&lang=js&"
export * from "./setPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdc5ffa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bdc5ffa')) {
      api.createRecord('5bdc5ffa', component.options)
    } else {
      api.reload('5bdc5ffa', component.options)
    }
    module.hot.accept("./setPassword.vue?vue&type=template&id=5bdc5ffa&scoped=true&", function () {
      api.rerender('5bdc5ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/header/setPassword.vue"
export default component.exports